import { useRef } from "react";

export const useAsyncValidation = (setFormData) => {
  const abortRef = useRef(null);

  const validatePincode = async (pincode) => {
    if (pincode.length !== 6) return;

    abortRef.current?.abort();
    abortRef.current = new AbortController();

    try {
      const res = await fetch(
        `https://api.postalpincode.in/pincode/${pincode}`,
        { signal: abortRef.current.signal }
      );
      const data = await res.json();

      if (data[0]?.Status === "Success") {
        const po = data[0].PostOffice[0];
        setFormData(prev => ({
          ...prev,
          city: po.District,
          state: po.State
        }));
      }
    } catch {}
  };

  return { validatePincode };
};
